export function formatDays(value: number | null | undefined): string | undefined {
	if (value == null || Number.isNaN(value)) return;
	return `${value}d`;
}
